import React, { useRef, useState } from 'react';

// Interactive 3D heart logo: mouse-tracking tilt, layered depth, orbital ring, glow.
export function Logo3D({ size = 112 }) {
  const ref = useRef(null);
  const [t, setT] = useState({ rx: 0, ry: 0 });

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    setT({ rx: -py * 22, ry: px * 22 });
  };
  const reset = () => setT({ rx: 0, ry: 0 });

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={reset}
      className="relative grid place-items-center animate-floaty"
      style={{ width: size * 1.9, height: size * 1.9, perspective: 900 }}
      data-testid="login-logo-3d"
    >
      {/* soft ground glow */}
      <div
        className="absolute rounded-full"
        style={{
          width: size * 1.35,
          height: size * 1.35,
          background: 'radial-gradient(circle, rgba(168,85,247,0.55), rgba(124,58,237,0) 70%)',
          filter: 'blur(26px)',
        }}
      />
      {/* orbital rings */}
      <div
        className="absolute rounded-full border animate-orbit"
        style={{ width: size * 1.7, height: size * 1.7, borderColor: 'rgba(232,121,249,0.28)', transform: 'rotateX(72deg)' }}
      />
      <div
        className="absolute rounded-full border animate-orbit-rev"
        style={{ width: size * 1.42, height: size * 1.42, borderColor: 'rgba(45,212,191,0.28)', transform: 'rotateX(72deg) rotateZ(60deg)' }}
      />

      {/* 3D card holding the heart */}
      <div
        className="relative rounded-[28%] transition-[transform] duration-200"
        style={{
          width: size,
          height: size,
          transformStyle: 'preserve-3d',
          transform: `rotateX(${t.rx}deg) rotateY(${t.ry}deg)`,
        }}
      >
        {/* back plate for depth */}
        <div
          className="absolute inset-0 rounded-[28%]"
          style={{
            transform: 'translateZ(-18px)',
            background: 'linear-gradient(135deg,#6D28D9,#4C1D95)',
            filter: 'blur(2px)',
            opacity: 0.7,
          }}
        />
        {/* main face */}
        <div
          className="absolute inset-0 rounded-[28%] grid place-items-center overflow-hidden"
          style={{
            background: 'linear-gradient(135deg,#F0ABFC 0%,#C084FC 35%,#7C3AED 100%)',
            boxShadow: '0 24px 50px -12px rgba(124,58,237,0.7), inset 0 2px 6px rgba(255,255,255,0.55), inset 0 -10px 22px rgba(76,29,149,0.55)',
            transform: 'translateZ(6px)',
          }}
        >
          {/* glossy sweep */}
          <div className="absolute -inset-1 aura-shimmer" />
          <i
            className="fa-solid fa-heart text-white relative"
            style={{ fontSize: size * 0.44, transform: 'translateZ(20px)', filter: 'drop-shadow(0 6px 10px rgba(76,29,149,0.6))' }}
          />
        </div>
        {/* floating sparkle */}
        <i
          className="fa-solid fa-sparkles absolute text-white/90"
          style={{ top: -6, right: -6, fontSize: size * 0.16, transform: 'translateZ(34px)', filter: 'drop-shadow(0 0 8px rgba(232,121,249,0.9))' }}
        />
      </div>
    </div>
  );
}
